<script lang="ts">
    import Link from "svelte-link/src/Link.svelte";
    import { Button, Image, Modal, ModalBody, ModalHeader } from "sveltestrap";
    import { Cancel, EmailAddress, General, href, Print, Printpreview } from "../../../utils/Constant/Constant";
    import {personalData} from "../../../store"
    export let getId:number 
    let open:boolean = false;
    let imgPath:string =  "/assets/images/user"
    let setPersonalData:any
    personalData.subscribe((value)=>{
      setPersonalData = value
    })
    const toggle = () => (open = !open);
</script>
<li>
  <Link href={href} on:click={toggle} >{Print}</Link>
</li>
<div class="modal fade modal-bookmark" id="printModal" tabindex="-1" role="dialog" aria-hidden="true">
    <Modal class="modal-dialog modal-dialog-centered" isOpen={open} {toggle} role="document">
      <div class="modal-content">
        <ModalHeader>{Printpreview}
          <Button class="btn-close" on:click={toggle} aria-label="Close"></Button>
        </ModalHeader>
        <ModalBody class="list-persons">
          <div class="profile-mail pt-0" id="DivIdToPrint">
            <div class="media">
                <Image fluid class="img-100 m-r-20 rounded-circle" id="updateimg" src="{imgPath}/2.png" alt="" />
              <div class="media-body mt-0">
                <h5>
                    <span id="printname">{setPersonalData[getId].fname} </span>
                    <span id="printlast">{setPersonalData[getId].lname}</span>
                </h5>
                <p id="printmail">{setPersonalData[getId].email}</p>
              </div>
            </div>
            <div class="email-general">
              <h6>{General}</h6>
              <p>{EmailAddress}: <span class="font-primary" id="mailadd">{setPersonalData[getId].email}</span></p>
            </div>
          </div>
          <Button color="secondary" on:click={toggle} >{Print}</Button>
          <Button color="primary" on:click={toggle}>{Cancel}</Button>
        </ModalBody>
      </div>
    </Modal>
</div>